// import { theme } from "../index";
import { updateCssVariables } from "@/utils/theme";
import { nextTick } from "vue";
export default {
  namespaced: true,
  state: {
    customTheme: false,
    customThemeVariables: localStorage.getItem("customThemeVariables") || {},
    selectedTheme: null,
  },
  mutations: {
    updateCustomThemeAvailability(state, value) {
      
      state.customTheme = value;
    },
    updateCustomThemeVariables(state, data) {
      updateCssVariables(data);
      state.customThemeVariables = data;
    },
    updateSelectedTheme(state, data) {
      state.selectedTheme = data;
    },
  },
  getters: {
    customTheme: (state) => state.customTheme,
    customThemeVariables: (state) => state.customThemeVariables,
    selectedTheme: (state) => state.selectedTheme,

    /**
     * Buttons met hoge prioriteit, of zaken die het meest in het oog moeten springen
     */
    btnMainBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["btn-main--background"]};`
        : `background-color: ${state.selectedTheme.theme.btnmainbackground};`;
    },
    leftCategoryNavigationBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["left-category-navigation--background"]};`
        : ``;
    },
    btnMainText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-main--text"]};`
        : ``;
    },

    /**
     * Buttons met normale prioriteit, op lichte achtergronden
     */
    btnSecondBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["btn-second--background"]};`
        : `background-color: ${state.selectedTheme.theme.btnsecondbackground};`;
    },
    btnSecondText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-second--text"]};`
        : ``;
    },

    /**
     * Buttons met lage prioriteit
     * Voor voor navigatie door schermen (back-button), next-button in lijsten, of openen van collapses
     */
    btnThirdBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["btn-third--background"]
        ? `background-color: ${state.customThemeVariables["btn-third--background"]};`
        : `background-color: ${state.selectedTheme.theme.btnthirdbackground};`;
    },
    headerButtonBackground: (state,getters) => { 
            return state.customTheme &&
        state.customThemeVariables["header-btn--background"]
        ? `background-color: ${state.customThemeVariables["header-btn--background"]};`
        : getters.btnThirdBackground;
    },
    btnThirdText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-third--text"]};`
        : `color: ${state.selectedTheme.theme.btnthirdtext};`;
    },
    btnThirdIcon: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-third--icon"]};`
        : `color: ${state.selectedTheme.theme.btnthirdicon};`;
    },

    /**
     * Outlined buttons, voorlopig enkel orderbuttons
     */
    btnOutlineBorder: (state) => {
      return state.customTheme
        ? `border-color: ${state.customThemeVariables["btn-outline--border"]};`
        : `border-color: ${state.selectedTheme.theme.btnoutlineborder};`;
    },
    btnOutlineBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["btn-outline--background"]};`
        : `background-color: ${state.selectedTheme.theme.btnoutlinebackground};`;
    },
    btnOutlineText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-outline--text"]};`
        : `color: ${state.selectedTheme.theme.btnoutlinetext};`;
    },
    btnOutlineIcon: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-outline--icon"]};`
        : `color: ${state.selectedTheme.theme.btnoutlineicon};`;
    },
    btnOutlineActiveBorder: (state) => {
      return state.customTheme
        ? `border-color: ${state.customThemeVariables["btn-outline-active--border"]};`
        : `border-color: ${state.selectedTheme.theme.btnoutlineactiveborder};`;
    },
    btnOutlineActiveBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["btn-outline-active--background"]};`
        : `background-color: ${state.selectedTheme.theme.btnoutlineactivebackground};`;
    },
    btnOutlineActiveText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-outline-active--text"]};`
        : `color: ${state.selectedTheme.theme.btnoutlineactivetext};`;
    },
    btnOutlineActiveIcon: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-outline-active--icon"]};`
        : `color: ${state.selectedTheme.theme.btnoutlineactiveicon};`;
    },

    btnDestructiveBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["btn-destructive--background"]};`
        : `background-color: ${state.selectedTheme.theme.btndestructivebackground};`;
    },
    btnDestructiveText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["btn-destructive--text"]};`
        : `color: ${state.selectedTheme.theme.btndestructivetext};`;
    },
    btnDestructiveIcon: (state) => {
      return state.customTheme &&
        state.customThemeVariables["btn-destructive--icon"]
        ? `${state.customThemeVariables["btn-destructive--icon"]}`
        : `${state.selectedTheme.theme.btndestructiveicon}`;
    },
    borderMain: (state) => {
      return state.customTheme
        ? `border-color: ${state.customThemeVariables["border-main"]};`
        : `border-color: ${state.selectedTheme.theme.bordermain};`;
    },
    borderOnBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["border-on-background"]};`
        : `color: ${state.selectedTheme.theme.borderonbackground};`;
    },
    backgroundMain: (state) => {
      return state.customTheme
        ? `background: ${state.customThemeVariables["background--main"]};`
        : `background: ${state.selectedTheme.theme.backgroundmain};`;
    },
    cartHeaderHeight: (state) => {
      return state.customTheme &&
        state.customThemeVariables["cart-header-height"]
        ? `height: ${state.customThemeVariables["cart-header-height"]};`
        : false;
    },
    cartBackground: (state,getters) => {
      return state.customTheme &&
        state.customThemeVariables["cart--background"] ?
        `background: ${state.customThemeVariables["cart--background"]};`
        : getters.mainSubCategorysBackground
    },
    headerLogoHeight: (state) => {
      return state.customTheme
        ? `height: ${state.customThemeVariables["header-logo-height"]};`
        : ``;
    },
    // kioskBackgroundMainScreen: (state) => {
    //   return state.customTheme &&
    //     state.customThemeVariables["kiosk-background-main--screen"]
    //     ? `background-color: ${state.customThemeVariables["kiosk-background-main--screen"]};`
    //     : (state.customThemeVariables["background-image"] ? `background-image: url(${state.customThemeVariables["background-image"]});` : `background-color: ${state.selectedTheme.theme.kioskbackgroundmainscreen};`)
    // },
    kioskBackgroundMainScreen: (state) => {
      const backgroundMainScreen = state.customThemeVariables["kiosk-background-main--screen"];
  
      // Regular expressions for checking if it's a hex code or a URL
      const hexCodeRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
      const urlRegex = /^(https?:\/\/|\/)/;

      if (state.customTheme && backgroundMainScreen) {
        if (hexCodeRegex.test(backgroundMainScreen)) {
          // If it's a hex code
          return `background-color: ${backgroundMainScreen};`;
        } else if (urlRegex.test(backgroundMainScreen)) {
          // If it's a URL
          return `background-image: url(${backgroundMainScreen});`;
        }
      }
    },
    backgroundModal: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["background--modal"]};`
        : `color: ${state.selectedTheme.theme.backgroundmodal};`;
    },
    modifierTitleBackground: (state) => { 
      return state.customTheme
      ? `${state.customThemeVariables["modifier-title--background"]}`: ``;
    },
    modifierContentBorderRadius: (state) => { 
      return state.customTheme
      ? `border-radius:${state.customThemeVariables["modifier-content--border-radius"]};`: ``; 
    },
    backgroundModalLayover: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["background--modal-layover"]};`
        : `color: ${state.selectedTheme.theme.backgroundmodallayover};`;
    },
    listsBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["lists--background"]};`
        : `background-color: ${state.selectedTheme.theme.listsbackground};`;
    },
    listsText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["lists--text"]};`
        : `color: ${state.selectedTheme.theme.liststext};`;
    },
    listsActiveBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["lists-active--background"]};`
        : `background-color: ${state.selectedTheme.theme.listsactivebackground};`;
    },
    listsActiveText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["lists-active--text"]};`
        : `color: ${state.selectedTheme.theme.listsactivetext};`;
    },
    text: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["text"]};`
        : `color: ${state.selectedTheme.theme.text};`;
    },
    titleMain: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["title-main"]};`
        : `color: ${state.selectedTheme.theme.titlemain};`;
    },
    titleSecond: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["title-second"]};`
        : `color: ${state.selectedTheme.theme.titlesecond};`;
    },
    titleThird: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["title-third"]};`
        : `color: ${state.selectedTheme.theme.titlethird};`;
    },
    cardMainBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["card-main--background"]};`
        : `color: ${state.selectedTheme.theme.cardmainbackground};`;
    },
    cardSecondaryBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["card-secondary--background"]};`
        : `background-color: ${state.selectedTheme.theme.cardsecondarybackground};`;
    },
    paymentBtnBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["payment-btn--background"]
        ? `background-color: ${state.customThemeVariables["payment-btn--background"]};`
        : `background-color: ${state.selectedTheme.theme.paymentbtnbackground};`;
    },
    proceedBtnBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["proceed-btn--background"]
        ? `background-color: ${state.customThemeVariables["proceed-btn--background"]};`
        : state.customThemeVariables["payment-btn--background"] ? `background-color: ${state.customThemeVariables["payment-btn--background"]};` : `background-color: ${state.selectedTheme.theme.paymentbtnbackground};`;
    },
    paymentBtnText: (state) => {
      return state.customTheme &&
        state.customThemeVariables["payment-btn--text"]
        ? `color: ${state.customThemeVariables["payment-btn--text"]};`
        : `color: ${state.selectedTheme.theme.paymentbtntext};`;
    },
    paymentFloatBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["payment-float--background"]};`
        : `background-color: ${state.selectedTheme.theme.paymentfloatbackground};`;
    },
    paymentFloatActiveBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["payment-float-active--background"]
        ? `color: ${state.customThemeVariables["payment-float-active--background"]};`
        : `color: ${state.selectedTheme.theme.paymentfloatactivebackground};`;
    },
    tipsFloatBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["tips-float--background"]};`
        : `color: ${state.selectedTheme.theme.tipsfloatbackground};`;
    },
    tabsBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["tabs--background"]};`
        : `color: ${state.selectedTheme.theme.tabsbackground};`;
    },
    tabsText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["tabs--text"]};`
        : `color: ${state.selectedTheme.theme.tabstext};`;
    },
    tabsActiveBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["tabs-active--background"]};`
        : `color: ${state.selectedTheme.theme.tabsactivebackground};`;
    },
    tabsActiveText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["tabs-active--text"]};`
        : `color: ${state.selectedTheme.theme.tabsactivetext};`;
    },
    tabsIcon: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["tabs--icon"]};`
        : `color: ${state.selectedTheme.theme.tabsicon};`;
    },
    summBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["summ--background"]};`
        : `color: ${state.selectedTheme.theme.summbackground};`;
    },
    summChildrenBackground: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["summ-children--background"]};`
        : `color: ${state.selectedTheme.theme.summchildrenbackground};`;
    },
    stepsBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["steps--background"]};`
        : `background-color: ${state.selectedTheme.theme.stepsbackground};`;
    },
    stepsBorder: (state) => {
      return state.customTheme
        ? `border-color: ${state.customThemeVariables["background--modal"]};`
        : `border-color: ${state.selectedTheme.theme.backgroundmodal};`;
    },
    stepsBackdropBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["background--modal"]};`
        : `background-color: ${state.selectedTheme.theme.backgroundmodal};`;
    },
    stepsText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["steps--text"]};`
        : `color: ${state.selectedTheme.theme.stepstext};`;
    },
    stepsNumber: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["steps--number"]};`
        : `color: ${state.selectedTheme.theme.stepsnumber};`;
    },
    stepsLine: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["steps--line"]};`
        : `color: ${state.selectedTheme.theme.stepsline};`;
    },
    stepsActiveBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["steps-active--background"]};`
        : `background-color: ${state.selectedTheme.theme.stepsactivebackground};`;
    },
    stepsActiveText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["steps-active--text"]};`
        : `color: ${state.selectedTheme.theme.stepsactivetext};`;
    },
    stepsActiveNumber: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["steps-active--number"]};`
        : `color: ${state.selectedTheme.theme.stepsactivenumber};`;
    },
    listActivePrice: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["list-active--price"]};`
        : `background-color: ${state.selectedTheme.theme.listactiveprice};`;
    },
    listActivePriceBorder: (state) => {
      return state.customTheme
        ? `border: ${state.customThemeVariables["list-active-border--price"]} 1px solid;`
        : `border: ${state.selectedTheme.theme.listactiveborderprice} 1px solid;`;
    },
    modifierShadowEnabled: (state) => { 
      if (state.customTheme && state.customThemeVariables["modifier-shadow--enabled"] == "false") return false;
      return true;
    },
    listActivePriceText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["list-active-price--text"]};`
        : `color: ${state.selectedTheme.theme.listactivepricetext};`;
    },
    mainSubCategorysBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["menu-sub-categorys--background"]
        ? `background: ${state.customThemeVariables["menu-sub-categorys--background"]};`
        :
        (state.customThemeVariables["background-image"] ? `background-image: url(${state.customThemeVariables["background-image"]});` : `background-color: ${state.selectedTheme.theme.mainsubcategorysbackground};`)
        
    },
    backgroundImage: (state) => {
      return state.customTheme &&
        state.customThemeVariables["background-image"]
        ? 'true'
        : ``;
    },
    menuSubCategoriesBackground:(state) => {
      const isHexColor = str => /^#([0-9A-F]{3}){1,2}$/i.test(str);
      let backgroundColor = false
      if (isHexColor(state.customThemeVariables["sub-categories--background"])) {
        backgroundColor = true
      }
      return state.customTheme &&
        state.customThemeVariables["sub-categories--background"]
        ? (backgroundColor ? `background-color: ${state.customThemeVariables["sub-categories--background"]};` : `background-image: url(${state.customThemeVariables["sub-categories--background"]});`)
        : false       
    },
    cartShadowColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["menu-sub-categorys--background"]
        ? `color: ${state.customThemeVariables["menu-sub-categorys--background"]};`
        : `color: ${state.selectedTheme.theme.mainsubcategorysbackground};`;
    },
    processTekst: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["process--tekst"]};`
        : `color: ${state.selectedTheme.theme.processtekst};`;
    },
    itemDescription: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["item--description"]};`
        : `color: ${state.selectedTheme.theme.itemdescription};`;
    },
    inputBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["input--background"]};`
        : `background-color: ${state.selectedTheme.theme.inputbackground};`;
    },
    inputBorder: (state) => {
      return state.customTheme
        ? `border-color: ${state.customThemeVariables["input--border"]};`
        : `border-color: ${state.selectedTheme.theme.inputborder};`;
    },

    paymentLoadingBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["payment-loading--background"]};`
        : `background-color: ${state.selectedTheme.theme.paymentloadingbackground};`;
    },
    buttonImgColors: (state) => {
      return state.customTheme &&
        state.customThemeVariables["button-img--colors"]
        ? `${state.customThemeVariables["button-img--colors"]}`
        : `${state.selectedTheme.theme.buttonimgcolors}`;
    },
    thankYouImgColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["thanks-you-img--colors"]
        ? `${state.customThemeVariables["thanks-you-img--colors"]}`
        : `${state.selectedTheme.theme.thanksyouimgcolor}`;
    },
    crossIconColor: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["lists-active--text"]}`
        : `${state.selectedTheme.theme.listsactivetext}`;
    },
    selectItemColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["select-item--color"]
        ? `${state.customThemeVariables["select-item--color"]}`
        : `${state.selectedTheme.theme.selectitemcolor}`;
    },
    selectItemActiveColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["select-item-active--color"]
        ? `${state.customThemeVariables["select-item-active--color"]}`
        : `${state.selectedTheme.theme.selectitemactivecolor};`;
    },
    itemBackground: (state) => {
      return state.customTheme && state.customThemeVariables["item--background"]
        ? `background-color: ${state.customThemeVariables["item--background"]};`
        : `background-color: ${state.selectedTheme.theme.itembackground};`;
    },
    additionAddBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["addition-add--background"]
        ? `background-color: ${state.customThemeVariables["addition-add--background"]};`
        : `background-color: ${state.selectedTheme.theme.additionaddbackground};`;
    },
    headerCancelOrderBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["header-cancel-order--background"]};`
        : ``;
    },
    headerCancelOrderColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["header-cancel-order--color"]};`
        : ``;
    },
    headerCancelOrderIcon: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["header-cancel-order--icon"]}`
        : ``;
    },
    headerCancelOrderBorder: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["header-cancel-order--border"]}`
        : ``;
    },
    landingsPageBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["landingspagebackground"]};`
        : ``;
    },
    landingsPageSelectionBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["landingspageselectionbackground"]};`
        : ``;
    },
    landingsPageSelectionBackgroundUrl: (state) => {
      return state.customTheme &&
        state.customThemeVariables["landingspageselectionbackgroundurl"]
        ? `background: url(${state.customThemeVariables["landingspageselectionbackgroundurl"]});`
        : ``;
    },
    backgroundMainFullImage: (state) => {
      return state.customTheme &&
        state.customThemeVariables["background-main--full-image"]
        ? `background-image: url(${state.customThemeVariables["background-main--full-image"]}); background-size: cover;background-repeat:no-repeat;`
        : ``;
    },
    landingsPageItemBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["landingspageitembackground"]};`
        : ``;
    },
    landingsPageTitle: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["landingspagetitle"]};`
        : ``;
    },
    landingsPageItemTitle: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["landingspageitemtitle"]};`
        : ``;
    },
    headerMainText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["header-main--text"]};`
        : ``;
    },
    kioskStartBackgroundButton: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-start-background--button"]};`
        : `background-color: ${state.selectedTheme.theme.kioskstartbackgroundbutton};`;
    },
    kioskArrow: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk--arrow"]}`
        : `${state.selectedTheme.theme.kioskarrow}`;
    },
    kioskCategoryTitle: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-category--title"]};`
        : `color: ${state.selectedTheme.theme.kioskcategorytitle};`;
    },
    modifierActionsBackground: (state) => {
      return state.customTheme ? `background-color: ${state.customThemeVariables["modifier-actions--background"]};` : ``;
     },
    kioskArrowBackground: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-arrow--background"]}`
        : `${state.selectedTheme.theme.kioskarrowbackground}`;
    },
    kioskBorder: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk--border"]}`
        : `${state.selectedTheme.theme.kioskborder}`;
    },
    kioskDetailBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-detail--background"]};`
        : `background-color: ${state.selectedTheme.theme.kioskdetailbackground};`;
    },
    kioskDetailText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-detail--text"]};`
        : `color: ${state.selectedTheme.theme.kioskdetailtext};`;
    },
    kioskCurrentCatBorder: (state) => {
      return state.customTheme
        ? `border-bottom: ${state.customThemeVariables["kiosk-current-cat-border-bottom"]} 6px solid;`
        : `border-bottom: ${state.selectedTheme.theme.kioskcurrentcatborder} 6px solid;`;
    },
    kioskCurrentCatBorderLeft: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-current-cat-border-bottom"]
        ? `border-left: ${state.customThemeVariables["kiosk-current-cat-border-bottom"]} 4px solid;`
        : `border-left: ${state.selectedTheme.theme.kioskcurrentcatborder} 4px solid;`;
    },
    kioskItemBorder: (state) => {
      return state.customTheme
        ? `border: ${state.customThemeVariables["kiosk-current-cat--border"]} 2px solid;`
        : `border: ${state.selectedTheme.theme.kioskcurrentcatborder} 2px solid;`;
    },
    activeUpsellItemBorder: (state) => {
      return state.customTheme
        ? `border: ${state.customThemeVariables["kiosk-current-cat--border"]} 4px solid;`
        : `border: ${state.selectedTheme.theme.kioskcurrentcatborder} 4px solid;`;
    },
    kioskModifierItemBorder: (state) => {
      return state.customTheme
        ? `border: ${state.customThemeVariables["kiosk-modifier-item-border"]} 2px solid;`
        : `border: ${state.selectedTheme.theme.kioskmodifieritemborder} 2px solid;`;
    },
    kioskItemOverviewBorder: (state) => {
      return state.customTheme
        ? `border: ${state.customThemeVariables["kiosk-item-overview--border"]} 2px solid;`
        : `border: ${state.selectedTheme.theme.kioskitemoverviewborder} 2px solid;`;
    },
    kioskItemOverviewBorderRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["kiosk-item-overview-border--radius"]};`
        : ``;
    },
    kioskItemOverviewBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-item-overview--background"]};`
        : ``;
    },
    kioskAdditionTitleLine: (state) => {
      return state.customTheme
        ? `border-bottom: ${state.customThemeVariables["kiosk-modifier-item-border"]} 2px solid;`
        : `border-bottom: ${state.selectedTheme.theme.kioskcurrentcatborder} 2px solid;`;
    },
    kioskAdditionTitleColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-addition-title--color"]};`
        : `color: ${state.selectedTheme.theme.kioskadditiontitlecolor};`;
    },
    kioskLastItemBackgroundColor: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-last-item-background--color"]};`
        : `background-color: ${state.selectedTheme.theme.kiosklastitembackgroundcolor};`;
    },
    kioskLastItemTitle: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-last-item--title"]};`
        : `color: ${state.selectedTheme.theme.kiosklastitemtitle};`;
    },
    kioskLastItemPrice: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-last-item--price"]};`
        : `color: ${state.selectedTheme.theme.kiosklastitemprice};`;
    },
    kioskPriceColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-price--color"]};`
        : `color: ${state.selectedTheme.theme.kioskpricecolor};`;
    },
    kioskTotalPrice: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-total--price"]};`
        : `color: ${state.selectedTheme.theme.kiosktotalprice};`;
    },
    kioskTotalColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-total--color"]};`
        : `color: ${state.selectedTheme.theme.kiosktotalcolor};`;
    },
    kioskCancelButtonBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-cancel-button--background"]};`
        : `background-color: ${state.selectedTheme.theme.kioskcancelbuttonbackground};`;
    },
    kioskCancelButtonColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-cancel-button--color"]};`
        : `color: ${state.selectedTheme.theme.kioskcancelbuttoncolor};`;
    },
    kioskPaymentButtonColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-payment-button--color"]};`
        : `color: ${state.selectedTheme.theme.kioskpaymentbuttoncolor};`;
    },
    kioskEatTodayTextDisplay: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-eat-today-text--display"]
        ? `display: ${state.customThemeVariables["kiosk-eat-today-text--display"]};`
        : ``;
    },
    deleteIconKioskBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["delete-icon-kiosk--background"]};`
        : `bckground-color: ${state.selectedTheme.theme.deleteiconkioskbackground};`;
    },
    totalPriceColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["total-price--color"]};`
        : `color: ${state.selectedTheme.theme.totalpricecolor};`;
    },
    totalPriceText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["total-price--text"]};`
        : `color: ${state.selectedTheme.theme.totalpricetext};`;
    },
    addMoreItemsIconBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["add-more-items-icon--background"]};`
        : `background-color: ${state.selectedTheme.theme.addmoreitemsiconbackground};`;
    },
    modifierAmountButtonBackground: (state) => { 
      return state.customTheme
      ? `background-color: ${state.customThemeVariables["modifier-amount-button--background"]};` : ``;
    },
    modifierAmountIconColor: (state) => {
      return state.customTheme ?
        `${state.customThemeVariables["modifier-amount-icon--color"]}` : ``
    },
    addMoreItemsIcon: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["add-more-items--icon"]}`
        : `${state.selectedTheme.theme.addmoreitemsicon}`;
    },
    addMoreItemsNumber: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["add-more-items--number"]};`
        : `color: ${state.selectedTheme.theme.addmoreitemsnumber};`;
    },
    modifierAmountNumberColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["modifier-amount-number--color"]};`
        : `color: ${state.selectedTheme.theme.addmoreitemsnumber};`;
    },
    modifierMaxTextColor: (state) => {
      return state.customTheme
      ? `${state.customThemeVariables["modifier-max-text--color"]}` : ``
    },
    QrMenuAppTitle: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["qr-menu-app--title"]}`
        : ``;
    },
    changeFont: (state) => {
      return state.customTheme && state.customThemeVariables["font"]
        ? `font-family: ${state.customThemeVariables["font"]};`
        : `font-family: Inter, Sans-serif;`;
    },
    titleFont: (state) => {
      return state.customTheme && state.customThemeVariables["title--font"]
      ? `font-family: ${state.customThemeVariables["title--font"]};`
      : `font-family: Inter, Sans-serif;`;
    },

    titleTextTransform: (state) => {
      return state.customTheme
      ? `text-transform: ${state.customThemeVariables["title--text-transform"]};`
      : `text-transform: none;`;
    },

    showLanguages: (state) => {
      return state.customTheme && state.customThemeVariables["languages"]
        ? `display: ${state.customThemeVariables["languages"]};`
        : ``;
    },

    showLandingsPageButton: (state) => {
      return state.customTheme &&
        state.customThemeVariables["show-landings-page--button"]
        ? `display: ${state.customThemeVariables["show-landings-page--button"]};`
        : ``;
    },
    currentColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-detail--text"]
        ? `${state.customThemeVariables["kiosk-detail--text"]}`
        : `${state.selectedTheme.theme.kioskdetailtext}`;
    },
    iconKioskHomepageColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["icon-kiosk-homepage--color"]
        ? `${state.customThemeVariables["icon-kiosk-homepage--color"]}`
        : `${state.selectedTheme.theme.iconkioskhomepagecolor}`;
    },
    smallOrderTypeIconColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["small-ordertype-icon--color"]
        ? `${state.customThemeVariables["small-ordertype-icon--color"]}`
        : `${state.selectedTheme.theme.iconkioskhomepagecolor}`;
    },
    textKioskHomepageColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["text-kiosk-homepage--color"]
        ? `color: ${state.customThemeVariables["text-kiosk-homepage--color"]};`
        : `color: ${state.selectedTheme.theme.textkioskhomepagecolor};`;
    },
    orderDetailSuccesfullPayment: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["order-detail-succesfull--payment"]};`
        : `color: ${state.selectedTheme.theme.orderdetailsuccesfullpayment};`;
    },
    orderDetailOrderNumber: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["order-detail-order--number"]};`
        : `color: ${state.selectedTheme.theme.orderdetailordernumber};`;
    },
    orderDetailBorder: (state) => {
      return state.customTheme &&
        state.customThemeVariables["order-detail--color"]
        ? `border: 1px solid ${state.customThemeVariables["order-detail--color"]};`
        : `border: 1px solid ${state.selectedTheme.theme.orderdetailordercolor};`;
    },
    orderDetailColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["order-detail--color"]};`
        : `color:  ${state.selectedTheme.theme.orderdetailordercolor};`;
    },
    orderDetailOrderBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["order-detail-order--background"]};`
        : `background-color: ${state.selectedTheme.theme.orderdetailorderbackground};`;
    },
    orderDetailInformationBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["order-detail-information--background"]};`
        : `background-color: ${state.selectedTheme.theme.orderDetailInformationBackground};`;
    },
    orderDetailInformationColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["order-detail-information--color"]};`
        : `color: ${state.selectedTheme.theme.orderDetailInformationColor};`;
    },
    orderDetailPageBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["order-detail-page--background"]};`
        : ``;
    },
    goBackButton: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["go-back--button"]};`
        : `background-color: ${state.selectedTheme.theme.gobackbutton};`;
    },
    goBackButtonText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["go-back-button--text"]};`
        : `color: ${state.selectedTheme.theme.gobackbuttontext};`;
    },
    pickupScreenHeaderBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-header--background"]
        ? `background-color: ${state.customThemeVariables["pickup-screen-header--background"]};`
        : `background-color: ${state.selectedTheme.theme.pickupscreenheaderbackground};`;
    },
    pickupScreenFirstTitle: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-first--title"]
        ? `color: ${state.customThemeVariables["pickup-screen-first--title"]};`
        : `color: ${state.selectedTheme.theme.pickupscreenfirsttitle};`;
    },
    pickupScreenSecondTitle: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-second--title"]
        ? `color: ${state.customThemeVariables["pickup-screen-second--title"]};`
        : `color: ${state.selectedTheme.theme.pickupscreensecondtitle};`;
    },
    pickupScreenThirdTitle: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-third--title"]
        ? `color: ${state.customThemeVariables["pickup-screen-third--title"]};`
        : `color: ${state.selectedTheme.theme.pickupscreenthirdtitle};`;
    },
    pickupScreenFirstBorder: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-first--border"]
        ? `border: 2px solid ${state.customThemeVariables["pickup-screen-first--border"]};`
        : `border: 2x solid ${state.selectedTheme.theme.pickupscreenfirstborder};`;
    },
    pickupScreenSecondBorder: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-second--border"]
        ? `border:2px solid ${state.customThemeVariables["pickup-screen-second--border"]};`
        : `border:2px solid ${state.selectedTheme.theme.pickupscreensecondborder};`;
    },
    pickupScreenThirdBorder: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-third--border"]
        ? `border:1px solid ${state.customThemeVariables["pickup-screen-third--border"]};`
        : `border:1px solid ${state.selectedTheme.theme.pickupscreenthirdborder};`;
    },
    pickupScreenRightBorder: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-right--border"]
        ? `border-right:1px solid ${state.customThemeVariables["pickup-screen-right--border"]};`
        : `border-right:1px solid ${state.selectedTheme.theme.pickupscreenrightborder};`;
    },
    pickupScreenFirstBackgroundStatus: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-first-background--status"]
        ? `background-color:${state.customThemeVariables["pickup-screen-first-background--status"]};`
        : `background-color: ${state.selectedTheme.theme.pickupscreenfirstbackgroundstatus};`;
    },
    pickupScreenSecondBackgroundStatus: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-second-background--status"]
        ? `background-color:${state.customThemeVariables["pickup-screen-second-background--status"]};`
        : `background-color: ${state.selectedTheme.theme.pickupscreensecondbackgroundstatus};`;
    },
    pickupScreenFirstTextStatus: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-first-text--status"]
        ? `color:${state.customThemeVariables["pickup-screen-first-text--status"]};`
        : `color: ${state.selectedTheme.theme.pickupscreenfirsttextstatus};`;
    },
    pickupScreenSecondTextStatus: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-second-text--status"]
        ? `color:${state.customThemeVariables["pickup-screen-second-text--status"]};`
        : `color: ${state.selectedTheme.theme.pickupscreensecondtextstatus};`;
    },
    pickupScreenFirstNameColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-first-name--color"]
        ? `color:${state.customThemeVariables["pickup-screen-first-name--color"]};`
        : `color: ${state.selectedTheme.theme.pickupscreenfirstnamecolor};`;
    },
    pickupScreenSecondNameColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-second-name--color"]
        ? `color:${state.customThemeVariables["pickup-screen-second-name--color"]};`
        : `color: ${state.selectedTheme.theme.pickupscreensecondnamecolor};`;
    },
    pickupScreenFirstOrderNumber: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-first-order--number"]
        ? `color:${state.customThemeVariables["pickup-screen-first-order--number"]};`
        : `color: ${state.selectedTheme.theme.pickupscreenfirstordernumber};`;
    },
    pickupScreenSecondOrderNumber: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-second-order--number"]
        ? `color:${state.customThemeVariables["pickup-screen-second-order--number"]};`
        : `color: ${state.selectedTheme.theme.pickupscreensecondordernumber};`;
    },
    pickupScreenThirdOrderNumber: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-third-order--number"]
        ? `color:${state.customThemeVariables["pickup-screen-third-order--number"]};`
        : `color: ${state.selectedTheme.theme.pickupscreenthirdordernumber};`;
    },
    pickupScreenMoreOrdersBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["pickup-screen-more-orders--background"]
        ? `background-color:${state.customThemeVariables["pickup-screen-more-orders--background"]};`
        : `background-color: ${state.selectedTheme.theme.pickupscreenmoreordersbackground};`;
    },
    upsellingTitleColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["upselling-item--color"]
        ? `color:${state.customThemeVariables["upselling-item--color"]};`
        : `color: ${state.selectedTheme.theme.upsellingitemcolor};`;
    },
    kioskBorderColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-border--color"]
        ? `border: ${state.customThemeVariables["kiosk-current-cat--border"]} 1.5px solid;`
        : `border: ${state.selectedTheme.theme.kioskbordercolor} 2px solid;`;
    },
    kioskNavBackgroundButtons: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-nav-background--buttons"]};`
        : `background-color: ${state.selectedTheme.theme.kiosknavbackgroundbuttons};`;
    },
    kioskNavIconColor: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-nav-icon--color"]}`
        : `${state.selectedTheme.theme.kiosknaviconcolor}`;
    },
    kioskNavActiveBarColor: (state) => {
      return state.customTheme
        ? `background: ${state.customThemeVariables["kiosk-nav-active-bar--color"]};`
        : `background: ${state.selectedTheme.theme.kiosknavactivebarcolor};`;
    },
    kioskPlusAndMinusButtons: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-plus-min-buttons"]}`
        : `${state.selectedTheme.theme.kioskplusminbuttons}`;
    },
    kioskKeyboardBackgroundColor: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-keyboard-background-color"]}`
        : `${state.selectedTheme.theme.kioskkeyboardbackgroundcolor}`;
    },
    kioskKeyboardKeyBackgroundColor: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-keyboard-key-background-color"]}`
        : `${state.selectedTheme.theme.kioskkeyboardkeybackgroundcolor}`;
    },
    kioskKeyboardKeyTextColor: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-keyboard-key-text-color"]}`
        : `${state.selectedTheme.theme.kioskkeyboardkeytextcolor}`;
    },
    kioskKeyboardTextColor: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["kiosk-keyboard-text-color"]}`
        : `${state.selectedTheme.theme.kioskkeyboardtextcolor}`;
    },
    remainingTimeButtonBackground: (state) => {
      return state.customTheme
        ? `background: ${state.customThemeVariables["remaining-time-button-background"]};`
        : `background: ${state.selectedTheme.theme.remainingtimebuttonbackground};`;
    },
    remainingTimeButtonText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["remaining-time-button-text"]};`
        : `color: ${state.selectedTheme.theme.remainingtimebuttontext};`;
    },
    kioskMainText: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-main-text--color"]};`
        : `color: ${state.selectedTheme.theme.kioskmaintext};`;
    },
    hideCategoryTitle: (state) => { 
      return state.customTheme && state.customThemeVariables["hide-category-title"]
        ? state.customThemeVariables["hide-category-title"]
        : true;
    },
    kioskNavCategoryName: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-nav-category--name"]
        ? `color: ${state.customThemeVariables["kiosk-nav-category--name"]};`
        : `color: ${state.selectedTheme.theme.kiosknavcategoryname};`;
    },
    kioskNavCategoryNameHeight: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-nav-category-name--height"]
        ? `font-size: ${state.customThemeVariables["kiosk-nav-category-name--height"]};`
        : '';
    },
    timeslotActiveBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["timeslot-active--background"]
        ? `background-color: ${state.customThemeVariables["timeslot-active--background"]};`
        : `background-color: ${state.selectedTheme.theme.timeslotactivebackground};`;
    },
    timeslotActiveColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["timeslot-active--color"]
        ? `color: ${state.customThemeVariables["timeslot-active--color"]};`
        : `color: ${state.selectedTheme.theme.timeslotactivecolor};`;
    },
    discountBtnBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-btn-background--color"]
        ? `background-color: ${state.customThemeVariables["discount-btn-background--color"]};`
        : `background-color: ${state.selectedTheme.theme.discountbtnbackgroundcolor};`;
    },
    discountBtnTextColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-btn-text--color"]
        ? `color: ${state.customThemeVariables["discount-btn-text--color"]};`
        : ``;
    },
    discountBtnIconColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-btn-text--color"]
        ? `${state.customThemeVariables["discount-btn-text--color"]};`
        : ``;
    },
    discountListBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-list-background--color"]
        ? `background-color: ${state.customThemeVariables["discount-list-background--color"]};`
        : `background-color: ${state.selectedTheme.theme.discountlistbackgroundcolor};`;
    },
    discountWarningColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-warning--color"]
        ? `color: ${state.customThemeVariables["discount-warning--color"]};`
        : `color: ${state.selectedTheme.theme.discountwarningcolor};`;
    },
    discountWarningAccentColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-warning-accent--color"]
        ? `border-color: ${state.customThemeVariables["discount-warning-accent--color"]};`
        : `border-color: ${state.selectedTheme.theme.discountwarningaccentcolor};`;
    },
    discountListItemValueColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-list-item-value--color"]
        ? `color: ${state.customThemeVariables["discount-list-item-value--color"]};`
        : `color: ${state.selectedTheme.theme.discountlistitemvaluecolor};`;
    },
    discountListItemDeleteButtonBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-list-item-delete-button-background--color"]
        ? `background-color: ${state.customThemeVariables["discount-list-item-delete-button-background--color"]};`
        : `background-color: ${state.selectedTheme.theme.discountlistitemdeletebuttonbackgroundcolor};`;
    },
    discountListItemDeleteButtonIconColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-list-item-delete-button-icon--color"]
        ? `${state.customThemeVariables["discount-list-item-delete-button-icon--color"]}`
        : `${state.selectedTheme.theme.discountlistitemdeletebuttoniconcolor}`;
    },
    discountAppliedTotalColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["discount-applied-total--color"]
        ? `color: ${state.customThemeVariables["discount-applied-total--color"]};`
        : `color: ${state.selectedTheme.theme.discountappliedtotalcolor};`;
    },
    warningColr: (state) => {
      return state.customTheme &&
        state.customThemeVariables["warning--color"]
        ? `color: ${state.customThemeVariables["warning--color"]};`
        : `color: ${state.selectedTheme.theme.warningcolor};`;
    },
    welcomeHeaderHeight: (state) => {
      return state.customTheme &&
        state.customThemeVariables["welcome-header--height"]
        ? `min-height: ${state.customThemeVariables["welcome-header--height"]};`
        : `height: 12rem`;
    },
    welcomeLogoHeight: (state) => {
      return state.customTheme
        ? `height: ${state.customThemeVariables["welcome-logo--height"]};`
        : ``;
    },
    kioskHeaderBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["kiosk-header--background"]};`: ``
    },
    orderTypeIconSize: (state) => {
      return state.customThemeVariables["order-type-icon-size"]
        ? `${state.customThemeVariables["order-type-icon-size"]}`
        : ``;
    },
    orderTypeButtonShadow: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["order-type-button--shadow"]}`
        : ``;
    },
    screensaverTime: (state) => {
      return state.customTheme
        ? `${state.customThemeVariables["screensaver-time"]}`
        : ``;
    },
     selectedLanguageButtonBackground: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["selected-language-button--background"]}`
        : `background-color: ${state.selectedTheme.theme.selectedlanguagebuttonbackground}`;
    },
     languageButtonBackground: (state) => {
      return state.customTheme 
        ? `background-color: ${state.customThemeVariables["language-button--background"]}`
        : ``;
    },
    categoryCarouselHeight: (state) => {
      return state.customTheme
        ? `height: ${state.customThemeVariables["category-carousel--height"]}`
        : ``;
    },
    categoryCarouselTotalHeight: (state) => {
      return state.customTheme
        ? `height: ${state.customThemeVariables["category-carousel-total--height"]}`
        : ``;
    },
    categoryCarouselBorderColor: (state) => {
      return state.customTheme
        ? `border-color: ${state.customThemeVariables["category-carousel-border-color"]}`
        : ``;
    },
    verticalOrderTypeButtonLayout: (state) => {
      return state.customTheme &&
        state.customThemeVariables["vertical-order-type-button--layout"]
        ? `${state.customThemeVariables["vertical-order-type-button--layout"]}`
        : ``;
    },
    kioskSearchBorderColor: (state) => {
      return state.customTheme
        ? `border: 2px solid ${state.customThemeVariables["kiosk-search-border-color"]};`
        : ``;
    },
    kioskSearchTextColor: (state) => {
      return state.customTheme
        ? `color: ${state.customThemeVariables["kiosk-search-text-color"]};`
        : ``;
    },
    kioskSearchIconColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-search-text-color"]
        ? `${state.customThemeVariables["kiosk-search-text-color"]}`
        : `#000000`;
    },
    isSearchEnable: (state) => {
      return state.customTheme &&
        state.customThemeVariables["search-enable"]
        ? `${state.customThemeVariables["search-enable"]}`
        : true;
    },
    currentModifierIndexColor: (state) => {
          return state.customTheme
            ? `color: ${state.customThemeVariables["current-modifier-index-color"]};`
            : ``;
    },
    currentModifierIndexBackground: (state) => {
          return state.customTheme
            ? `background-color: ${state.customThemeVariables["current-modifier-index-background-color"]};`
            : ``;
    },
    menuItemShadow: (state) => {
      if (state.customTheme && state.customThemeVariables["menu-item-shadow"]) {
        if (state.customThemeVariables["menu-item-shadow"] === 'medium') {
          return 'shadow-xl';
        } else if (state.customThemeVariables["menu-item-shadow"] === 'large') {
          return 'shadow-2xl';
        } else if (state.customThemeVariables["menu-item-shadow"] === 'none') {
          return '';
        } else {
          return 'shadow-lg';
        }
      } else {
        return 'shadow-lg';
      }
    },
    selectedMenuRoundBackground: (state) => {
          return state.customTheme
            ? `background-color: ${state.customThemeVariables["selected-menu-round-background-color"]};`
            : ``;
    },
    orderTypeButtonOpacity: (state) => {
          return state.customTheme
            ? `opacity: ${state.customThemeVariables["order-type-button--opacity"]};`
            : ``;
    },
    languageButtonTextColor: (state) => {
          return state.customTheme
            ? `color: ${state.customThemeVariables["language-button-text--color"]};`
            : ``;
    },
    categoryCarouselBackgroundColor: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["category-carousel-background-color"]}`
        : ``;
    },
    verticalCategoryCarouselWidth: (state) => {
      return state.customTheme &&
        state.customThemeVariables["vertical-category-carousel--width"]
        ? `width: ${state.customThemeVariables["vertical-category-carousel--width"]}`
        : `false`;
    },
    verticalCategoryCarouselHeight: (state) => {
      return state.customTheme &&
        state.customThemeVariables["vertical-category-carousel--height"]
        ? `height: ${state.customThemeVariables["vertical-category-carousel--height"]}`
        : `height: 80vh`;
    },
    verticalCategoryCarouselBackgroundColor: (state) => {
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["vertical-category-carousel--background-color"]}`
        : ``;
    },
    verticalCategoryCarouselBorderRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["vertical-category-carousel--border-radius"]}`
        : ``;
    },
    menuItemBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["menu-item-background-color"]
            ? `${state.customThemeVariables["menu-item-background-color"]}`
            : ``;
    },
    carouselItemsCount: (state) => {
      return state.customTheme &&
        state.customThemeVariables["carousel-items-count"]
            ? `${state.customThemeVariables["carousel-items-count"]}`
            : ``;
    },
    isStaticSideMenu: (state) => {
      return state.customTheme &&
        state.customThemeVariables["is-static-side-menu"]
            ? `${state.customThemeVariables["is-static-side-menu"]}`
            : false;
    },
    modalBackground: (state) => {
      return state.customTheme &&
        state.customThemeVariables["modal-background"]
            ? `${state.customThemeVariables["modal-background"]}`
            : `#FFFFFF`;
    },
    cartItemImageWidth: (state) => {
      return state.customTheme &&
        state.customThemeVariables["cart-item-image-width"]
            ? `width: ${state.customThemeVariables["cart-item-image-width"]}`
            : ``;
    },
    userDetailsLabelColor: (state) => {
      return state.customTheme
            ? `color: ${state.customThemeVariables["user-details-label-color"]}`
            : ``;
    },
    userDetailsInputBackgroundColor: (state) => {
      return state.customTheme
            ? `background-color: ${state.customThemeVariables["user-details-input-background-color"]}`
            : ``;
    },
    userDetailsInputTextColor: (state) => {
      return state.customTheme
            ? `color: ${state.customThemeVariables["user-details-input-text-color"]}`
            : ``;
    },
    paymentTextColor: (state) => {
      return state.customTheme
             ? `color: ${state.customThemeVariables["payment-text-color"]}`
            : ``;
    },




    //  Border Radius.

    mainSectionRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["main-section--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.mainsectionradius};`;
    },
    mainSectionTopRadius: (state) => {
      return state.customTheme
        ? `border-top-left-radius: ${state.customThemeVariables["main-section--radius"]};
            border-top-right-radius: ${state.customThemeVariables["main-section--radius"]};`
        :  `border-top-left-radius: ${state.selectedTheme.theme.mainsectionradius};
            border-top-right-radius: ${state.selectedTheme.theme.mainsectionradius};`
        
    },
      kioskLandingPageCardRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["kiosk-landing-page-card--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.kiosklandingpagecardradius};`;
    },
    languageButtonRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["language-button--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.languagebuttonradius};`;
    },
    languageButtonBorderColor: (state) => {
      return state.customTheme
        ? `border: ${state.customThemeVariables["language-button--border-color"]} 2px solid;`
        : ``;
    },
    continueButtonBackground: (state) => { 
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["continue-button--background"]};`
        : ``;
    },
    cancelButtonBackground: (state) => { 
      return state.customTheme
        ? `background-color: ${state.customThemeVariables["cancel-button--background"]};`
        : ``;
    },
    cancelButtonFillBackground: (state) => { 
      return state.customTheme
        ? `${state.customThemeVariables["cancel-button-fill--background"]}`
        : ``;
    },
      menuItemRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["menu-item--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.menuitemborderradius};`;
    },
    addButtonRadius: (state) => {
      return state.customTheme
       ? `border-radius: ${state.customThemeVariables["add-button--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.menuitemborderradius};`;
    },
    mainButtonRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["main-button--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.mainbuttonradius};`;
    },
    secondButtonRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["second-button--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.secondbuttonradius};`;
    },
    cartSectionRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["cart-section--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.cartsectionradius};`;
    },
    cartSectionTopRadius: (state) => {
      return state.customTheme
        ? `border-top-left-radius: ${state.customThemeVariables["cart-section--radius"]};
          border-top-right-radius: ${state.customThemeVariables["cart-section--radius"]};`
        : `border-top-left-radius: ${state.selectedTheme.theme.cartsectionradius};
          border-top-right-radius: ${state.selectedTheme.theme.cartsectionradius};`
    },
    itemAdditionsRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["item-additions--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.itemadditionsradius};`;
    },
    cartProcessItemRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["cart-process-item--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.cartprocessitemradius};`;
    },
    cartItemRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["cart-item--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.cartitemradius};`;
    },
    cartProcessInputRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["cart-process-input--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.cartprocessinputradius};`;
    },
    progressBarRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["cart-progress--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.cartprogressradius};`;
    },
    categoryCarouselRadius: (state) => {
      return state.customTheme
        ? `border-radius: ${state.customThemeVariables["category-carousel--radius"]};`
        : `border-radius: ${state.selectedTheme.theme.categorycarouselradius};`;
    },
    kioskKeyboardKeysRadius: (state) => {
      return state.customTheme &&
        state.customThemeVariables["kiosk-keyboard-keys--radius"]
        ? `${state.customThemeVariables["kiosk-keyboard-keys--radius"]}`
        : `${state.selectedTheme.theme.kioskkeyboardkeysradius}`;
    },
    cartDestructiveButtonColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["cart-destructive-button--color"]
        ? `${state.customThemeVariables["cart-destructive-button--color"]}`
        : `#ffffff`;
    },
    cartItemDestructiveButtonColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["cart-item-destructive-button--color"]
        ? `${state.customThemeVariables["cart-item-destructive-button--color"]}`
        : `#FFFFFF`;
    },
    cartDestructiveButtonBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["cart-destructive-button---background-color"]
        ? `background-color: ${state.customThemeVariables["cart-destructive-button---background-color"]}`
        : `background-color: ${state.customThemeVariables["btn-destructive--background"]};`;
    },
    cartItemDestructiveButtonBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["cart-item-destructive-button---background-color"]
        ? `background-color: ${state.customThemeVariables["cart-item-destructive-button---background-color"]}`
        : ``;
    },
    languageModalDestructiveBackgroundColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["language-modal-destructive-background-color"]
        ? `background-color: ${state.customThemeVariables["language-modal-destructive-background-color"]}`
        : ``;
    },
    languageModalDestructiveIconColor: (state) => {
      return state.customTheme &&
        state.customThemeVariables["language-modal-destructive-icon-color"]
        ? `${state.customThemeVariables["language-modal-destructive-icon-color"]}`
        : `#f86262`;
    },
    

  },
};
